import React, { Component } from 'react';
import { isEmpty } from "lodash";

import { normalizeStr } from '../../../utils/generalFuncs';
import Dialog from '../../common/Dialog';
import InputText from '../../common/Form';

class LabelForm extends Component {
    state = { 
        label_name: this.props.label ? this.props.label.label_name : "",
        errors:{
            label_name: "",
        }
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        this.setState({
            [name]: value
        })
    }
    validate = () => {
        let required = [
            "label_name",
            
        ]
        
        let noError = true
        let errors = {}
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    
    nameExist = (name, id) => {
        const { LABELS } = this.props;
        let list = []
        list = Object.values(LABELS).filter(item =>  ( 
            (normalizeStr(item.label_name) === normalizeStr(name) ) && 
            (item.label_id !== id) 
        ) )
            
        console.log("Item exist",{list});
        return !isEmpty(list)
    }
    handleSubmit = async () => {
        if(this.validate()){
            let data = {}
            if (this.props.update) {
                data = Object.assign(data, this.props.label)
            }
            data.label_name = this.state.label_name.toUpperCase()
    
            console.log('====================================');
            console.log({data});
            console.log('====================================');
            
            // check if name exist
            if(this.nameExist(data.label_name, data.label_id) ){
                this.props.notif("error",`Ce Label existe déjà`)
                return
            }

            if(this.props.update){
                await this.props.updateLabel(data)
            } else {
                await this.props.newLabel(data)  
            }

            if(this.props.STATE.labels.error){
                console.log('====================================');
                console.log("ERROR", this.props.STATE.labels );
                console.log('====================================');
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.labels.error}`)
            } else {
                !this.props.update && this.props.notif("success","Le label a été créé avec succès")
                this.props.update && this.props.notif("success","Le label a été modifiée avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        return (
            <Dialog
                close={this.props.handleClose}
                appBar
                title={`${this.props.update ? "Modifier le " : "Créer un nouveau"} Label`}
                submitAction={this.handleSubmit} 
                disabledSubmit={this.props.STATE.labels.fetching}
                submitTitle={this.props.update ? "Modifier" : "Créer"}
            >
                <InputText
                    required
                    name="label_name" 
                    id="label_name" 
                    value={this.state.label_name} 
                    label="Nom" 
                    placeholder="Nom du label" 
                    error={this.state.errors.label_name} 
                    onChange={this.handleChange}
                />
                    
            </Dialog>

        );
    }
}

export default LabelForm;